import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';

/**
 * Zendesk SSO logout route (DEV-11861).
 *
 * Public, top-level state at `/zendesk/logout` (no auth guard), mirroring the
 * `zendeskLogin` splash layout. The view is rendered entirely by the downgraded
 * Angular component `<ng-zendesk-logout>` (see
 * apps/b2b-frontend/app/features/zendesk-logout).
 *
 * Zendesk redirects the user here with a `return_to` query param (the deep link
 * they were trying to reach) to end the Backoffice session. It is declared on
 * the URL so ui-router preserves it across the hybrid transition; the component
 * reads it and forwards it onto the `/zendesk/login` URL after sign-out so the
 * deep link survives the round trip.
 */
export const ZendeskLogoutView = angular
  .module('acme.view.zendeskLogout', [uiRouter])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'zendeskLogout',
      url: '/zendesk/logout?return_to',
      abstract: true,
      views: {
        main: {
          templateUrl: 'layouts/standard.tpl.html',
        },
      },
      data: {
        pageClass: 'application-splash',
        pageTitle: 'Zendesk Sign Out',
      },
    });

    $stateProvider.state({
      name: 'zendeskLogout.default',
      url: '',
      views: {
        'subview-main': {
          template: '<ng-zendesk-logout></ng-zendesk-logout>',
        },
      },
    });
  }).name;
